import api from './api';

export const shuService = {
  // Get SHU settings for a year
  getSHUSettings: (year) => 
    api.get(`/shu/settings/${year}`),

  // Update SHU settings for a year
  updateSHUSettings: (year, data) => 
    api.put(`/shu/settings/${year}`, data),

  // Calculate SHU (traditional method)
  calculateSHU: (year) => 
    api.get(`/shu/calculate/${year}`),

  // Calculate SHU based on weighted deposits (lama mengendap)
  calculateSHUWeighted: (year) => 
    api.get(`/shu/calculate-weighted/${year}`),
};
